import React, { useContext, useState } from "react";
import "./Library.css";
import LibrarySubjectProps from "./LibrarySubject/LibrarySubjectProps";
import LibraySubjectDetail from "./LibraySubjectDatail/LibrarySubjectDetail";
import { useEffect } from "react";
import axios from "../../axios";
import LibraryTour from "../../SidebarHeader/Header/LibraryTour";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import { Link } from "react-router-dom";
import HeaderContext from "../../HeaderContext";
import HistoryDetaulsPopup from "../HistoryDetailsPopup";
export default function LibraryMain() {
  const [studentData, setStudentData] = useState();
  let Student_Id = JSON.parse(localStorage.getItem("breathForStudent"));

  const [librayMain, setLibraryMain] = useState({
    subjectDetail: false,
    continuePopSubject: true,
  });


  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [moralStory, setMoralStory] = useState([])
  const [openPop, setopenPop] = useState(false)
  const [getMoralStory, setGetMoralStory] = useState(null)
  const [isGettingData, setIsGettingData] = useState(false);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem('hasShownPopupLibrary');
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem('hasShownPopupLibrary', 'true');
    }
  }, []);
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const fetchData = async () => {
      const date = getCurrentDate();
      const standardId = Student_Id?.standard?.id;

      try {
        setIsGettingData(true)
        const response = await axios.get(`/messageBoard/wellnessSectionStory/get?standardId=${standardId}&date=${date}`);
        console.log("Data from API:", response.data.data);
        response && setMoralStory(response.data.data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    setIsGettingData(false)
    fetchData();
  }, []);
  const [steps, setSteps] = useState([

    {
      element: ".home",
      intro: `
        <h3>Home</h3>
        <p>Home has 4 features (as shown in left most pane):
       </p>
       <ol>
          <li>My Feed</li>
          <li>Library</li>
          <li>Calendar</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPane",
      intro: `
        <h3>Features Group Left Pane
        Home has 3 features as shown:</h3>
        <ol>
          <li>My Feed</li>
          <li>Library</li>
          <li>Calendar</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".library",
      intro: `
        <h3>Library</h3>
        <p>You are in library, under home parent</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".subjectsList",
      intro: `
        <h3>Subjects List</h3>
        <p>You will find curriculum subject lists here. Click on any subject to see its content.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".suggestedMaterials ",
      intro: `
        <h3>Suggested Study Materials</h3>
        <p>You will find external suggested study materials here. Click on any material to see details</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);
  const onExit = () => {
    setStepsEnabled(false);
  };

  const handleSubjectDetail = () => {
    setLibraryMain({
      ...librayMain,
      subjectDetail: true,
    });
  };
  const handleSubjectDetailClose = () => {
    setLibraryMain({
      ...librayMain,
      subjectDetail: false,
    });
  };

  const handleSubjectContiueClose = () => {
    setLibraryMain({
      ...librayMain,
      continuePopSubject: false,
    });
  };
  const [subjectDatas, setSubjectDatas] = useState([]);
  const [externalStudyMaterial, setExternalStudyMaterial] = useState([]);
  useEffect(() => {
    let result = JSON.parse(localStorage.getItem("breathForStudent"));
    setStudentData(result);
    const handleSubjectData = async () => {
      let res = await axios.get(
        `/cm/library/book/getSubjectByClassSection?standard_id=${result?.standard?.id}&section_id=${result?.section?.id}&timetable_session=${result?.timetable_session?.id}`
      );
      setSubjectDatas(res.data.data);
      let res1 = await axios.get(
        `/cm/library/book/getExternalMaterialByClassSection?standard_id=${result?.standard?.id}&section_id=${result?.section?.id}`
      );
      setExternalStudyMaterial(res1?.data?.data);
    };
    handleSubjectData();
  }, []);

  const reduceParagraphLength = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + "...";
  }
  return (
    <>
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      {!librayMain.subjectDetail && (
        <div className="MainContainerLibrary">

          <div className="row">
            <div className="col-md-9 subjectsList">
              <div className="main-content">
                <div className="heading-text">
                  <span className="text1">SELECTION OF</span><span className="text2"> INTERACTIVE </span><span className="text3">AND </span><span className="text4">INSIGHTFUL</span><br />
                  <span className="text5"> DIGITAL MULTIMEDIA CONTENTS, </span><br />
                  <span className="text6">JUST FOR YOU</span>
                </div>
                <div className="heading-image">
                  <img src="/images/digital_library.png" alt="img" />
                </div>
              </div>
              <div className="library-subject">
                <div className="curr-heading"> Curriculum</div>
                <LibrarySubjectProps
                  handleSubjectDetail={handleSubjectDetail}
                  studentDetails={studentData}
                  subjects={subjectDatas}
                />
              </div>
              <div>
                <div className="sugestedHeading">
                  Competition preparation packages
                </div>
                <div className="competition-content">
                  <div className="competition-image">
                    <img
                      src="/HomePageImg/noClass.svg"
                      className=""
                      alt=""
                    ></img>
                  </div>
                  <div className="competition-text">
                    Oops!! You are not enrolled to any Competition Preparation Packages.
                  </div>
                </div>
                {/* {
                  externalStudyMaterial.length > 0 ? (
                    <div className="totalSubContainerSideStudyMateril">
                      {externalStudyMaterial?.length > 0 &&
                        externalStudyMaterial?.map((obj, index) => (
                          <Link
                            key={index}
                            href={obj.URL}
                            style={{ textDecoration: "none" }}
                          >

                            <div>
                              <div className="d-flex justify-content-between mt-3">
                                <span className="teacherNameLibrary">
                                  {obj?.PostedBy}
                                </span>
                                <span className="subjectNamesLibrary ">
                                  English Teacher
                                </span>
                              </div>
                              <div className="textSugestedStudy mt-2">
                                {obj?.Description}
                              </div>
                              <div className="horizontalLineLibrary mt-4"></div>
                            </div>
                          </Link>
                        ))}
                    </div>) : (<div className="noClass">
                      <div className="d-flex gap-2 justify-content-center flex-column align-items-center">
                        <img
                          src="/HomePageImg/noClass.svg"
                          className=""
                          alt=""
                        ></img>
                        <div className="">
                          <span>No Items Found!</span>
                        </div>
                      </div>
                    </div>)
                } */}
              </div>
            </div>
            <div className="col-md-3 totalContainerSideStudyMateril suggestedMaterials">
              <div className="wellness-content">
                <div className="wellness-text">
                  Wellness Section
                </div>
                <div className="wellness-image">
                  <img src="/images/Moral_Student.png" alt="img" />
                </div>
              </div>
              <div className="moral-data-container">
                {
                  moralStory?.map((data, i) => {
                    console.log("dats")
                    return (
                      <div className="moral-content" key={i} onClick={() => { setopenPop(true); setGetMoralStory(data) }}>
                        <div className="moral-text">
                          <div className="title">{data?.title ? data?.title : ` Nothing Interesting Today `}</div>
                          <div className="content-type">{data?.b4s_category === "Moral Story of the Day" ? "Moral" : data?.b4s_category === "Inspirational Story of the Day" ? "Inspirational" : null}</div>
                        </div>
                        <div className="moral-img-desc">
                          <div className="moral-image">
                            <img
                              className="moralimage"
                              src={data.Image ? data?.Image : "/images/Default_Inspirational_Stories_Icon.png"}
                              alt="img"
                            />
                          </div>
                          <div className="moral-desc">{reduceParagraphLength(data?.Description || '', 180)} </div>
                        </div>
                        <hr style={{ margin: "14px 5px" }} />
                      </div>
                    )
                  })
                }
              </div>


              {/* <div className="sugestedHeading">
                Suggested External Study Material
              </div>
              {
                externalStudyMaterial.length > 0 ? (
                  <div className="totalSubContainerSideStudyMateril">
                    {externalStudyMaterial?.length > 0 &&
                      externalStudyMaterial?.map((obj, index) => (
                        <Link
                          key={index}
                          href={obj.URL}
                          style={{ textDecoration: "none" }}
                        >

                          <div>
                            <div className="d-flex justify-content-between mt-3">
                              <span className="teacherNameLibrary">
                                {obj?.PostedBy}
                              </span>
                              <span className="subjectNamesLibrary ">
                                English Teacher
                              </span>
                            </div>
                            <div className="textSugestedStudy mt-2">
                              {obj?.Description}
                            </div>
                            <div className="horizontalLineLibrary mt-4"></div>
                          </div>
                        </Link>
                      ))}
                  </div>) : (<div className="noClass">
                    <div className="d-flex gap-2 justify-content-center flex-column align-items-center">
                      <img
                        src="/HomePageImg/noClass.svg"
                        className=""
                        alt=""
                      ></img>
                      <div className="">
                        <span>No Items Found!</span>
                      </div>
                    </div>
                  </div>)
              } */}
            </div>
          </div>
        </div>
      )}
      {homeScreenWalkThroughPopup && (
        <LibraryTour
          setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
          setStepsEnabled={setStepsEnabled}
        />
      )}
      {
        openPop && (
          <HistoryDetaulsPopup setopenPop={setopenPop} news={getMoralStory} isGettingData={isGettingData} />
        )
      }
      {/* {librayMain.subjectDetail && <LibraySubjectDetail handleSubjectDetailClose={handleSubjectDetailClose} subjectDeltail={librayMain.continuePopSubject } handleSubjectContiueClose={handleSubjectContiueClose} />} */}
    </>
  );
}
